
<h3>Sponsor {{index + 1}}</h3>
<div id="{{sponsor.masterCustomerId}}" class="delete-file-button" (click)="deleteSponsor($event.target.id)"></div>
<div class="bold">{{sponsor.labelName}}</div>
<div class="italic">{{sponsor.companyName}}</div>
<div>{{searchResultDisplayCity}}</div>